<template>
	<ContentWrapper class="main-container" :class="{ mobile: isMobile, external: external}">
		<notifications group="principal" position="bottom center"/>
		<BuscarAtivoForm v-if="!isMobile && external" @acaoRealizada="adicionarAtivo"/>
		<Cabecalho v-else class="cabecalho" @acaoRealizada="ativoAdicionado"/>

		<div class="page-content">
			<EvolucaoRentabilidade
				class="evolucao-rentabilidade" ref="chart"
				@graficoRenderizado="onGraficoRenderizado"
				:forcarRenderizacao="forcarRenderizacaoGfx"/>
			<ListaRentabilidadeAtivo
				:periodoSelecionado="indicePeriodo"
				:forcarRenderizacao="forcarRenderizacaoTbl"
				@acaoRealizada="ativoRemovido"
				@highlightOnChart="highlightOnChart"/>
		</div>
	</ContentWrapper>
</template>

<script>
import Vue from "vue"
import Cabecalho from "@/app/components/Desktop/share/Cabecalho"
import EvolucaoRentabilidade from "@/app/components/Desktop/Charts/EvolucaoRentabilidade"
import ListaRentabilidadeAtivo from "@/app/components/Desktop/share/ListaRentabilidadeAtivo"
import BuscarAtivoForm from "@/app/components/Desktop/Forms/BuscarAtivoForm"

export default {
	components: {
		Cabecalho,
		EvolucaoRentabilidade,
		ListaRentabilidadeAtivo,
		BuscarAtivoForm,
	},
	data() {
		return {
			indicePeriodo: 0,
			indexadoresAtivos: [],
			forcarRenderizacaoGfx: 0,
			forcarRenderizacaoTbl: 0,
		}
	},
	beforeCreate: function () {
		if (this.$route.query.dark) {
			document.body.className = "dark"
			document.table.classname = document.table.classname + "dark"
		}
	},
	beforeMount() {
		this.indexadoresAtivos = this.$store.getters.getIndexadores
	},
	methods: {
		adicionarAtivo(props) {
            window.scrollTo(0, 0)

			Vue.notify({
				title: "Sucesso",
				type: "success",
				group: "principal",
				text: "Ativo adicionado com sucesso.",
				duration: 5000,
			})

			this.$store.commit("addAtivo", props.ativo)
			this.ativoAdicionado()
		},
		ativoAdicionado() {
			this.forcarRenderizacaoGrafico()
			this.forcarRenderizacaoTabelas()
		},
		ativoRemovido() {
			this.forcarRenderizacaoGrafico()
			this.forcarRenderizacaoTabelas()
		},
		onGraficoRenderizado() {
			this.indexadoresAtivos = this.$store.getters.getIndexadores.filter(
				(indx) => indx.selecionado
			)
			this.forcarRenderizacaoTabelas()
		},
		forcarRenderizacaoGrafico() {
			this.forcarRenderizacaoGfx++
		},
		forcarRenderizacaoTabelas() {
			this.forcarRenderizacaoTbl++
		},
		highlightOnChart(seriesName, out) {
			if (this.$refs.chart) {
				this.$refs.chart.highlightOnChart(seriesName, out)
			}
		}
	},
	computed: {
		external() {
			return this.$route.query.external
		},
		isMobile() {
            return this.$mq == 'mobile'
        }
	},
}
</script>

<style lang="scss">
	.main-container {
		.page-content {
			margin-left: $sidebar-wd;
			padding: 42px 24px 42px;

			.offseted-content {
				padding-left: $chart-offset;

				> div {
					margin-top: 64px;
					padding-bottom: 18px;
					border-bottom: 1px solid rgba(36, 36, 36, 0.35);
				}
			}
		}
	}

	// External
	.main-container.external {
		.page-content {
			margin-left: 0;
		}
	}
	// Mobile
	.main-container.mobile {
		padding: 0 10px;

		.page-content {
			margin-left: 0;
			margin-bottom: 90px;
			padding: 0;
			padding-top: 44px;

			.offseted-content {
				padding-left: 0;

				> div {
					margin-top: 50px;
					padding-bottom: 10px;
				}
			}
		}

		table {
			caption {
				font-size: 20px;
			}

			th, td {
				font-size: 13px;
			}
		}

		.m-hidden { display: none; }
	}
</style>